import { useEffect, useState } from "react";
import { Save } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { budgetPayload } from "@/lib/budgetRows";

export function BudgetDescriptionBox({ budget, onSaved }) {
  const t = useT();
  const [text, setText] = useState(budget.notes || "");
  const [saving, setSaving] = useState(false);
  const dirty = text !== (budget.notes || "");

  useEffect(() => { setText(budget.notes || ""); }, [budget.id, budget.notes]);

  const save = async () => {
    if (budget.locked) { toast.error(t("Deze begroting is vergrendeld — ontgrendel eerst.")); return; }
    setSaving(true);
    try {
      await api.put(`/budgets/${budget.id}`, budgetPayload(budget, { notes: text.trim().slice(0, 1000) }));
      toast.success(t("Toelichting opgeslagen"));
      onSaved?.();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || String(e.message || e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="border-2 border-foreground bg-background p-3" data-testid={`budget-desc-${budget.year}`}>
      <div className="flex items-center justify-between mb-2 gap-2">
        <div className="flex items-center gap-2">
          <span className="font-display uppercase font-black text-xs tracking-widest">{t("Begroting")} {budget.year}</span>
          {budget.locked && <span className="text-xs text-primary uppercase font-bold">{t("Vergrendeld")}</span>}
        </div>
        <button onClick={save} disabled={saving || !dirty || budget.locked} data-testid={`budget-desc-save-${budget.year}`}
          className="btn-brutal bg-primary text-primary-foreground px-3 py-1.5 font-display uppercase font-bold text-xs disabled:opacity-40 disabled:cursor-not-allowed inline-flex items-center gap-1">
          <Save className="w-3 h-3" /> {saving ? t("Opslaan…") : t("Opslaan")}
        </button>
      </div>
      <textarea rows={2} value={text} onChange={(e) => setText(e.target.value)} maxLength={1000} disabled={budget.locked}
        placeholder={t("Beschrijving of aannames voor {y}: waarom deze cijfers, welke ontwikkelingen verwacht je? Verschijnt in de PDF-export.").replace("{y}", String(budget.year))}
        data-testid={`budget-desc-input-${budget.year}`}
        className="w-full border-2 border-foreground bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary disabled:opacity-60" />
      <div className="mt-1 text-[10px] text-muted-foreground text-right">{text.length}/1000</div>
    </div>
  );
}
